import React, { useEffect } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import { clearCachedAccessTokenProps, getUserName } from '../utils/tokenUtils';
import { logInfo } from '../services/LoggingService';

const AUTO_LOGOUT_DELAY_MS = 3000;

export function startAutomaticSignout({ account, userName, logInfo, clearCachedTokens, logout }) {
  const resolvedUserName = userName || 'unknown';
  const name = account?.name || 'unknown';

  logInfo(
    `AUTOMATIC SIGNOUT started for userName = ${resolvedUserName} (${name})`,
    'MS-ENTRA Authentication',
  );
  clearCachedTokens();

  const logoutTimer = window.setTimeout(logout, AUTO_LOGOUT_DELAY_MS);
  return () => window.clearTimeout(logoutTimer);
}

const Signout = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const account = instance.getActiveAccount();
    return startAutomaticSignout({
      account,
      userName: getUserName(),
      logInfo,
      clearCachedTokens: clearCachedAccessTokenProps,
      logout: () => instance.logout(),
    });
  }, [instance]);

  return (
    <Container fluid className="py-5">
      <Row className="justify-content-center">
        <Col md={9} lg={7} xl={6}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4 p-md-5 text-center">
              <div className="mb-3 text-warning" aria-hidden="true">
                <i className="bi bi-clock-history" style={{ fontSize: '3rem' }}></i>
              </div>
              <h1 className="h3 mb-3">Your session has expired</h1>
              <p className="lead mb-4">
                To help protect your account, Telescope has signed you out after a period of inactivity.
              </p>
              <p className="text-muted mb-0" role="status">
                You will be returned to the sign-in page shortly.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Signout;